// extracted by mini-css-extract-plugin
export var underlinedLink = "_t2-0";